<template>
  <b-card>
    <div v-if="isLoading" class="text-center my-3">
      <b-spinner variant="primary" label="Carregando..." />
    </div>

    <div v-else-if="ajuste.id">
      <div class="d-flex justify-content-between align-items-center mb-2">
        <h2 class="mb-0">
          <feather-icon icon="FileTextIcon" size="28" class="text-primary mr-1" />
          Detalhes do Ajuste de Conta
        </h2>
        <b-badge :variant="ajuste.tipoContabil === 'RECEITA' ? 'success' : 'danger'" class="font-medium-2 p-50">
          Ajuste de {{ ajuste.tipoContabil === 'RECEITA' ? 'Crédito' : 'Débito' }}
        </b-badge>
      </div>

      <hr />

      <b-row>
        <b-col md="6" class="mb-2">
          <h5 class="text-primary mb-1">Dados da Movimentação</h5>
          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>Conta Afetada:</span>
              <span class="font-weight-bold">{{ ajuste.conta ? ajuste.conta.descricao : 'N/A' }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>Data do Registro:</span>
              <span>{{ formatDateGrid(ajuste.data) }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>Valor do Ajuste:</span>
              <span class="font-weight-bold" :class="ajuste.tipoContabil === 'RECEITA' ? 'text-success' : 'text-danger'">
                {{ ajuste.tipoContabil === 'RECEITA' ? '+' : '-' }} {{ formatCurrencyBrazil(ajuste.valor || 0) }}
              </span>
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <b-col md="6" class="mb-2">
          <h5 class="text-primary mb-1">Informações do Sistema</h5>
          <b-list-group>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>Autor do Ajuste:</span>
              <span>{{ ajuste.user ? ajuste.user.username : 'Sistema' }}</span>
            </b-list-group-item>
            <b-list-group-item class="d-flex justify-content-between align-items-center">
              <span>Módulo:</span>
              <span>Financeiro - Ajustes Manuais</span>
            </b-list-group-item>
          </b-list-group>
        </b-col>

        <b-col md="12" class="mt-1">
          <h5 class="text-primary mb-1">Motivo / Observações</h5>
          <b-card bg-variant="light" text-variant="dark">
            <b-card-text>{{ ajuste.obs }}</b-card-text>
          </b-card>
        </b-col>
      </b-row>

      <div class="mt-2 text-right">
        <b-button variant="secondary" @click="goBack">Voltar</b-button>
      </div>
    </div>
  </b-card>
</template>

<script>
import {
  BCard, BRow, BCol, BBadge, BButton, BListGroup, BListGroupItem, BSpinner, BCardText
} from 'bootstrap-vue'
import mixinsGlobal from '@/mixins'

export default {
  name: 'AjusteContaDetail',
  components: {
    BCard, BRow, BCol, BBadge, BButton, BListGroup, BListGroupItem, BSpinner, BCardText
  },
  mixins: [mixinsGlobal],
  data() {
    return {
      isLoading: true,
      ajuste: {}
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    async loadData() {
      const id = this.$route.params.id
      if (!id) {
        this.goBack()
        return
      }

      this.isLoading = true
      try {
        const response = await this.$store.dispatch('ajusteContaFinancialModule/findById', id)
        if (response && response.data) {
          this.ajuste = response.data
        } else {
          this.MensagemError('Erro', 'Ajuste não encontrado.')
          this.goBack()
        }
      } catch (e) {
        this.MensagemError('Erro', 'Falha na requisição.')
        this.goBack()
      } finally {
        this.isLoading = false
      }
    },
    goBack() {
      // Retorna para a aba de histórico de ajustes caso ele tenha chegado via contas, ou historico
      this.$router.push({ name: 'ajuste-conta-list' })
    }
  }
}
</script>
